<template>
  <div class="navigation" v-if="this.$vuetify.breakpoint.lgAndUp">
    <v-layout class="navigation_lay" row>
      <v-col cols="3"></v-col>
      <v-col cols="6">
        <div>
          <router-link :to="`/${$i18n.locale}/`">
            <v-img class="title justify-center" src="../assets/Pascal-De-Munck-white-hires.png"></v-img>
          </router-link>
        </div>
      </v-col>
      <v-col cols="3">
        <ul class="main-nav">
          <li>
            <router-link :to="`/${$i18n.locale}/portfolio`">{{ $t('titels.portfolio') }}</router-link>
          </li>
          <li class="ml-4">
            <router-link :to="`/${$i18n.locale}/birds`">{{ $t('titels.birds') }}</router-link>
          </li>
          <li class="ml-4">
            <router-link :to="`/${$i18n.locale}/mammal`">{{ $t('titels.mammal') }}</router-link>
          </li>
          <li class="ml-4">
            <router-link :to="`/${$i18n.locale}/recent`">{{ $t('titels.recent') }}</router-link>
          </li>
          <li class="ml-4">
            <router-link :to="`/${$i18n.locale}/travel`">{{ $t('titels.travel') }}</router-link>
          </li>
          <li class="ml-4 mr-2">
            <div v-if="!fullScreen" @click="openFullscreen()">
              <v-icon color="white" class="logo">mdi-fullscreen</v-icon>
            </div>
            <div v-if="fullScreen" @click="closeFullscreen()">
              <v-icon color="white" class="logo">mdi-fullscreen-exit</v-icon>
            </div>
          </li>
          <li class="ml-2 mr-2">
            <LanguageSwitcher class="test" />
          </li>
        </ul>
      </v-col>
    </v-layout>
  </div>
  <div v-else class="navigation_phone">
    <v-layout>
      <v-col cols="3"></v-col>
      <v-col cols="6">
        <router-link :to="`/${$i18n.locale}/`">
        <v-img v-if="this.$vuetify.breakpoint.md" class="title-phone justify-center" src="../assets/Pascal-De-Munck-white-hires.png"></v-img>
        </router-link>
        <router-link :to="`/${$i18n.locale}/`">
        <v-img v-if="this.$vuetify.breakpoint.sm" class="title-phone-sm justify-center" src="../assets/Pascal-De-Munck-white-hires.png"></v-img>
        </router-link>
        <router-link :to="`/${$i18n.locale}/`">
        <v-img v-if="this.$vuetify.breakpoint.xs" class="title-phone-xs justify-center" src="../assets/Pascal-De-Munck-white-hires.png"></v-img>
        </router-link>
      </v-col>
      <v-col cols="3">
        <v-layout row>
          <v-menu transition="slide-x-reverse-transition" max-width="250px">
            <template v-slot:activator="{ on }">
              <v-icon class="mt-4 menu_icon" color="white" v-on="on">mdi-menu</v-icon>
            </template>
            <v-card>
              <v-list class="dropdown">
                <v-list-item>
                  <div class="icon mr-4">
                  <v-img src="../assets/bird_logo.png"></v-img>
                  </div>
                  <router-link
                    class="black--text"
                    style="text-decoration: none"
                    :to="`/${$i18n.locale}/birds`"
                  >
                    <v-list-item-title><h4>{{ $t('titels.birds') }}</h4></v-list-item-title>
                  </router-link>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <div class="icon mr-4">
                    <v-img src="../assets/26103.png"></v-img>
                  </div>
                  <router-link
                    class="black--text"
                    style="text-decoration: none"
                    :to="`/${$i18n.locale}/mammal`"
                  >
                    <v-list-item-title><h4>{{ $t('titels.mammal') }}</h4></v-list-item-title>
                  </router-link>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <div class="icon mr-4">
                    <v-img src="../assets/recent_logo.png"></v-img>
                  </div>
                  <router-link
                    class="black--text"
                    style="text-decoration: none"
                    :to="`/${$i18n.locale}/recent`"
                  >
                    <v-list-item-title><h4>{{ $t('titels.recent') }}</h4></v-list-item-title>
                  </router-link>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <div class="icon mr-4">
                    <v-img src="../assets/world.png"></v-img>
                  </div>
                  <router-link
                    class="black--text"
                    style="text-decoration: none"
                    :to="`/${$i18n.locale}/travel`"
                  >
                    <v-list-item-title><h4>{{ $t('titels.travel') }}</h4></v-list-item-title>
                  </router-link>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <div class="icon mr-4">
                    <v-img src="../assets/portfolio_icon.png"></v-img>
                  </div>
                  <router-link
                    class="black--text"
                    style="text-decoration: none"
                    :to="`/${$i18n.locale}/portfolio`"
                  >
                    <v-list-item-title><h4>{{ $t('titels.portfolio') }}</h4></v-list-item-title>
                  </router-link>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
          <li class="ml-4 mt-5 list_flag mr-2">
            <LanguageSwitcher class="test_phone" />
          </li>
        </v-layout>
      </v-col>
    </v-layout>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import LanguageSwitcher from "../components/LanguageSwitcher.vue";
export default {
  name: "ContentHeader",
  components: {
    LanguageSwitcher
  },
  computed: {
    ...mapState(["fullScreen"])
  },
  methods: {
    ...mapMutations(["CHANGE_FULLSCREEN"]),
    openFullscreen() {
      var elem = document.documentElement;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari & Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }
      this.CHANGE_FULLSCREEN();
    },
    closeFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE/Edge */
        document.msExitFullscreen();
      }
      this.CHANGE_FULLSCREEN();
    }
  }
};
</script>

<style>
.test {
  position: absolute;
  top: 3px;
}
.test_phone {
  transform: scale(1.3);
}
.menu_icon {
  transform: scale(1.3);
}
.dropdown {
  height: 100vh;
  width: 300px;
}
.icon {
  width: 1%;
}

.list_flag {
  list-style: none;
}
.title {
  width: 210px;
  height: 75px;
  margin: auto;
}
.logo {
  width: 15%;
  max-height: 100%;
  position: absolute;
  top: 0;
  left: 40%;
}
/************NAVIGATION **************/

.navigation {
  background-image: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7));
  width: 100%;
}

.navigation_lay {
  width: 100%;
  height: 10%;
}

.main-nav {
  float: right;
  list-style: none;
  position: absolute;
  top: 40%;
  right: 3%;
}

.main-nav li {
  display: inline-block;
}

.main-nav li a:link,
.main-nav li a:visited {
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 85%;
}

.main-nav li a::after {
  content: "";
  display: block;
  width: 0;
  height: 3px;
  border-radius: 500px;
  background: #2980b9;
  transition: width 0.4s;
}

.main-nav li a:hover::after,
.main-nav li a:active::after {
  width: 100%;
}

/******NAVIGATION PHONE ********/
.navigation_phone {
  background-image: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7));
  height: 10%;
}

.title-phone {
  width: 210px;
  height: 75px;
  margin: auto;
}
.title-phone-sm {
  width: 210px;
  height: 75px;
  margin: auto;
}
.title-phone-xs {
  width: 190px;
  height: 67px;
  margin: auto;
}
</style>